import axios, { AxiosError } from 'axios';
import { COUNT_MEDIA_BY_DATE_URL } from '../../const/const';
import { CountMedia } from '../../types/CountMedia';

interface DateRange {
    start: string;
    end: string;
}

interface CountMediaByDateItem {
    day: string;
    photo: number;
    audio: number;
    video: number;
}

interface CountMediaByDateResponse {
    data: CountMediaByDateItem[];
    error?: string;
    success: boolean;
}

export const getCountMediaByDate = async (
    SmartDVRToken: string,
    userLogin: string
): Promise<CountMediaByDateResponse | undefined> => {
    const COUNT_MEDIA_URL = COUNT_MEDIA_BY_DATE_URL;

    if (!userLogin || !SmartDVRToken) {
        console.error('User information is missing.');
        return;
    }

    try {
        const response = await axios.get(
            COUNT_MEDIA_URL,
            {
                headers: {
                    SmartDVRLogin: userLogin,
                    SmartDVRToken: SmartDVRToken,
                },
            }
        );
        return response.data;
    } catch (error) {
        const err = error as AxiosError;
        console.error('Error fetching count media by date:', err.response?.status, err.response?.data);
        return { data: [], error: String(err.response?.data) || 'Unknown error', success: false };
    }
}; 